import { FC } from 'react';
import { HStack } from '@chakra-ui/react';

import { TaxForecastProfileMainActivityType } from '__generated__/GQL';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';

import { locales } from '../../locales';

export enum IsReglemented {
  YES = 'YES',
  NO = 'NO',
}

interface ReglementedLiberalProps {
  value?: IsReglemented;
  onChange: (value: IsReglemented) => void;
}

const ReglementedLiberal: FC<ReglementedLiberalProps> = ({
  onChange,
  value,
}) => {
  return (
    <SunshineCard.Group isActive>
      <SunshineCard
        title={locales.activityType.liberal.label}
        value={TaxForecastProfileMainActivityType.Liberal}
        variant="radio"
      />
      <SunshineCard.RadioGroup
        onChange={onChange}
        padding="space-16"
        value={value}
      >
        <Text fontWeight="weight-500" variant="primary">
          {locales.activityType.liberal.question}
        </Text>
        <HStack width="225px">
          <SunshineCard
            title={locales.activityType.liberal.yes}
            value={IsReglemented.YES}
            variant="radio"
          />
          <SunshineCard
            title={locales.activityType.liberal.no}
            value={IsReglemented.NO}
            variant="radio"
          />
        </HStack>
      </SunshineCard.RadioGroup>
    </SunshineCard.Group>
  );
};

export default ReglementedLiberal;
